export class VenueMeetingItem {
  requestId: number;
  venueId: number;
  meetingDate: string;
  meetingToDate: string;
  startTimeHours: number;
  startTimeHours24: number;
  startTimeMinutes: number; 
  startTimeSymbol: string;
  endTimeHours: number;
  endTimeHours24: number;  
  endTimeMinutes: number; 
  endTimeSymbol: string;
  meetingStart: Date; 
  meetingEnd: Date;
  startMilliseconds: number; 
  endMilliseconds: number;
  durationHours: number;
  durationMinutes: number;
  isWeekend: boolean;
  isTimeAvailable: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/venue-meeting-item.ts